export const fetchText = async (url: string): Promise<string> => {
  const response = await fetch(url);
  if (!response.ok) {
    throw new Error(`Failed to fetch ${url}: ${response.status}`);
  }
  return response.text();
};

// Zones are optional: a failed fetch shouldn't fail the map.
export const fetchTextOrNull = async (url: string | null | undefined): Promise<string | null> => {
  if (!url) {
    return null;
  }

  try {
    return await fetchText(url);
  } catch {
    return null;
  }
};
